import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddStorageSpaceTypePageNew from "../../components/StorageSpaceType/AddStorageSpaceTypePageNew";



const AddStorageSpaceTypePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Storage Type" link2="/space-type" title="Add Storage Type" />

        {/* AddUserLayer */}
        <AddStorageSpaceTypePageNew />


      </MasterLayout>
    </>
  );
};

export default AddStorageSpaceTypePage;
